import classnames from 'classnames';
import { SfaPlayerStatCardProps } from './sfaPlayerStatCard.types';
import styles from './sfaPlayerStatCard.module.scss';

// Renders as a description list item so screen readers announce "label:
// value" properly. The parent `.stats` grid uses a <dl> wrapper.
const SfaPlayerStatCard = ({
  nativeProps = {},
  classNames = [],
  testId = 'sfa-player-stat-card',
  label,
  value,
}: SfaPlayerStatCardProps) => (
  <div
    {...nativeProps}
    data-testid={testId}
    className={classnames(styles.sfaPlayerStatCard, classNames)}
  >
    <dt className={styles.label}>{label}</dt>
    <dd className={styles.value}>{value}</dd>
  </div>
);

export default SfaPlayerStatCard;
